import clsx from 'clsx'
import {isSelectiveAiDomains} from 'common/HelperFunctions'
import {useEffect} from 'react'

import {ToolbarType, useLayout} from '../../core'
import {Toolbar} from './Toolbar'
import {PageTitleWrapper} from './page-title'

/**
 * The slim row under the app header: page title and breadcrumb on the left,
 * route-specific controls (dashboard filter) on the right.
 */
const ToolbarWrapper = () => {
  const {config, classes} = useLayout()

  const rendered = !!config.app?.toolbar?.display && !isSelectiveAiDomains()

  // Metronic zeroes `.app-content`'s top padding while a toolbar is present
  // (see layout/_content.scss). Toolbar.tsx only ever sets the flag, so clear
  // it here when the row is not rendered or the content would sit flush
  // against the header on every page after the first toolbar mount.
  useEffect(() => {
    if (rendered) {
      document.body.setAttribute('data-kt-app-toolbar-enabled', 'true')
    } else {
      document.body.removeAttribute('data-kt-app-toolbar-enabled')
    }
  }, [rendered])

  if (!rendered) {
    return null
  }

  const isPageTitleVisible = showPageTitle(
    config.app?.toolbar?.layout,
    config.app?.pageTitle?.display
  )

  return (
    <div
      id='kt_app_toolbar'
      className={clsx('app-toolbar', classes.toolbar.join(' '), config?.app?.toolbar?.class)}
    >
      <div
        id='kt_app_toolbar_container'
        className={clsx(
          'app-container',
          classes.toolbarContainer.join(' '),
          config.app?.toolbar?.containerClass,
          config.app?.toolbar?.minimize?.enabled ? 'app-toolbar-minimize' : '',
          {
            'container-fluid': config.app?.toolbar?.container === 'fluid',
            'container-xxl': config.app?.toolbar?.container === 'fixed',
          }
        )}
      >
        {isPageTitleVisible && <PageTitleWrapper />}
        <Toolbar />
      </div>
    </div>
  )
}

const showPageTitle = (appToolbarLayout?: ToolbarType, appPageTitleDisplay?: boolean): boolean => {
  const viewsWithPageTitles = ['classic', 'reports', 'saas', 'ilmversity']
  if (!appToolbarLayout || !appPageTitleDisplay) {
    return false
  }

  return appPageTitleDisplay && viewsWithPageTitles.some((t) => t === appToolbarLayout)
}

export {ToolbarWrapper}
